import React, { useEffect, useState } from 'react';

import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  TextareaAutosize,
  Typography,
} from '@mui/material';

import { Reason } from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { EHR } from '../../../../tasks/types/ehr';
import { ReasonsChoicePanel } from '../../ReasonsChoicePanel';
import { RequiredFieldErrorBar } from '../../RequiredFieldErrorBar';
import styles from '../../styles.module.scss';

export const EHRLayout = ({
  data,
  setData,
  isExpanded,
  reasons,
  error,
}: {
  data: EHR;
  setData: React.Dispatch<React.SetStateAction<EHR>>;
  isExpanded: boolean;
  reasons: Reason[];
  error: boolean;
}) => {
  const [reasonDescription, setReasonDescription] = useState(
    data.reasonDescription || '',
  );
  const [selectedReasons, setSelectedReasons] = useState(
    data.reason || ([] as string[]),
  );
  const [doctorInfo, setDoctorInfo] = useState(data.doctorInfo ?? '');
  const [id] = useState(Math.random().toFixed(6).substring(2));

  useEffect(() => {
    const newData = {} as EHR;
    if (isExpanded) {
      newData.reason = selectedReasons;
      newData.reasonDescription = reasonDescription;
      newData.doctorInfo = doctorInfo;
      // orderBackupAps is depricated we'll remove from backend too later
      newData.orderBackupAps = false;
    } else {
      setReasonDescription('');
      setSelectedReasons([] as string[]);
      setDoctorInfo('');
    }
    setData(newData);
  }, [isExpanded, reasonDescription, selectedReasons.length, doctorInfo]);

  return (
    <Box>
      {error && (
        <Box mb={1}>
          <RequiredFieldErrorBar />
        </Box>
      )}

      <Box>
        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          {Resource.DESCRIPTION}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2">
          Medical history, diagnoses, medications, treatment, immunization,
          allergies, radiology images, laboratory and test results.
        </Typography>
      </Box>
      <Box mt={3}>
        <Paper
          elevation={0}
          style={{ backgroundColor: 'var(--neutrals-night-10)' }}
        >
          <Box p={1.5} pt={1.5}>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              {Resource.ORDER_REASON}
            </Typography>
            <ReasonsChoicePanel
              reasons={reasons}
              selectedReasons={selectedReasons}
              selectReasonsCallback={setSelectedReasons}
            />
            <Box mt={2}>
              <TextareaAutosize
                name="reason"
                data-tid={`${id}-reason-textarea`}
                placeholder="Describe the reason"
                className={styles.MUTextareaInput}
                onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
                  setReasonDescription(ev.currentTarget.value);
                }}
                value={reasonDescription}
                minRows={3}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
